export default __webpack_public_path__ + "static/media/IMG-20241005-WA0008.981def2f.jpg";